import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
//@ts-ignore
import ICountUp from 'vue-countup-v2';
let IconBoxContent = class IconBoxContent extends Vue {
};
IconBoxContent = __decorate([
    Component({
        props: ['title', 'value', 'showCustom', 'cssClass', 'centerContent'],
        data() {
            return {};
        },
        created() {
            // 
        },
        computed: {
            centerStyle() {
                if (this.$props.centerContent === true) {
                    return "text-align:center";
                }
            },
        },
        components: {
            ICountUp,
        },
    })
], IconBoxContent);
export default IconBoxContent;
